import { apiClient } from '../client';
import { RequestData } from '../../../contract/dtos';
/**
 * Create a new tenant registration request
 * @param requestData - The request data
 */
export const createRequest = async (requestData: RequestData) => {
  const response = await apiClient.post('/corporate/v1/request', requestData);
  return response.data;
};